/** @format */
import UserProfile from "./user-profile";

export default UserProfile;
